if (!customElements.get('elvarinio-product-carousel')) {
  customElements.define('elvarinio-product-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.rail = this.querySelector('.elv-products');
      this.previous = this.querySelector('[data-elv-prev]');
      this.next = this.querySelector('[data-elv-next]');
      this.controls = this.querySelector('[data-elv-controls]');
      if (!this.rail || !this.previous || !this.next || !this.controls) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.previous.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      this.rail.addEventListener('scroll', () => this.queueUpdate(), { passive: true, signal });
      this.observer = new ResizeObserver(() => this.queueUpdate());
      this.observer.observe(this.rail);
      this.queueUpdate();
    }

    move(direction) {
      const card = this.rail.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
      const step = card.getBoundingClientRect().width + gap;
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.rail.scrollBy({ left: direction * step, behavior: reducedMotion ? 'auto' : 'smooth' });
    }

    queueUpdate() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        const maximum = this.rail.scrollWidth - this.rail.clientWidth;
        this.previous.disabled = this.rail.scrollLeft <= 2;
        this.next.disabled = this.rail.scrollLeft >= maximum - 2;
        this.controls.hidden = maximum <= 2;
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
